import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { palette } from 'styled-tools';

import { useAnalytics } from '@/hooks/analytics';
import { Gift } from '@/hooks/purchase/useGiftPurchase';

import messages from './messages';

const Message = styled.div`
	color: ${palette('gray7')};
	text-align: left;
	line-height: 1.6rem;
`;

const Title = styled.h4`
	text-align: left;
	color: ${palette('gray7')};
	height: 2.5rem;
`;

interface PurchaseConfirmationProps {
	gifts: Gift[];
	email: string;
	giftType: 'annual' | 'lifetime';
}

const PurchaseConfirmation = ({ gifts, email, giftType }: PurchaseConfirmationProps) => {
	const { formatMessage } = useIntl();
	const { logEvent } = useAnalytics();
	logEvent({
		eventName: 'Gift : Purchase : Confirmation : Landed',
		eventProps: {
			quantity: gifts.length,
		},
	});

	return (
		<div id="purchase-confirmation">
			<Title>{formatMessage(messages.purchaseConfirmationTitle)}</Title>
			<Message>
				{formatMessage(
					giftType === 'lifetime'
						? messages.purchaseLifetimeConfirmationDescription
						: messages.purchaseConfirmationDescription,
					{
						quantity: gifts.length.toString(),
						email: <b>{email}</b>,
						herelink: chunks => (
							<b>
								<a href="https://support.calm.com">{chunks}</a>
							</b>
						),
					},
				)}
			</Message>
		</div>
	);
};

export default PurchaseConfirmation;
